module.exports = {"id":"dp3_2l1q2","text":"Integrating and re-elaborating digital content","instructions":"What is a benefit of exploring digital content integration tools?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.2","questionType":"PickOne","random":true,"options":[{"id":"dp3_2l1q2-a1","text":"They help combine and refine existing content","score":1.8},{"id":"dp3_2l1q2-a2","text":"They eliminate the need for human review","score":0},{"id":"dp3_2l1q2-a3","text":"They prevent ethical obligations when editing","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.2/l1q2.json
// module id = 1131
// module chunks = 41